import React from 'react';
import { useTranslation } from 'react-i18next';

//components
import { DefaultButton } from 'components/styled/Button';

interface ICancelButton {
  disabled?: boolean;
  onClick: () => void;
  label?: string;
  visibility?: string;
}

export const CancelButton = ({ disabled, onClick, label, visibility }: ICancelButton) => {
  const { t } = useTranslation();

  return (
    <DefaultButton
      onClick={onClick}
      disabled={disabled}
      type="button"
      color="white"
      visibility={visibility}
    >
      {t(label || 'Cancel')}
    </DefaultButton>
  );
};
